export default {
    data() {
        return {
            visible_reject: false,
            selected_record: {}
        }
    },
    methods: {
        on_reject(record) {
            this.selected_record = record;
            this.visible_reject = true;
        },
    }
}